import { render } from "./ModalEmergencyContacts.vue?vue&type=template&id=d672a324&ts=true"
import script from "./ModalEmergencyContacts.vue?vue&type=script&lang=ts"
export * from "./ModalEmergencyContacts.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__